﻿
(() => {
    angular.module('fliptoWeb')
        .constant('config',
        {
            //enables some functionality useful for debug
            //disables popup windows on social sharing and other mobile related options.
            //ENSURE THIS IS FALSE FOR PRODUCTION RELEASE
            isDebugMode: window["isDevMode"],
            isIntro: window["isIntro"],
            isPartner: window["isPartner"]
        });
})()